/*
   Theme Selector
 */

import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { setJourneyNavStep, setPersonalizedName } from '../../actions/journey-actions'
import { personalizedName } from '../../selectors/journeyState-selectors'
import '../../css/EnterYourName.css'
import Hammer from "react-hammerjs";
import { tapOptions } from '../../utils/hammerOptions';
import Keyboard from './Keyboard'


class EnterYourName extends React.Component {
   constructor(props) {
      super(props)
      this.state = { personalizedName: '', name: '' }
   }

   componentWillMount(props) {
      this.setState({personalizedName: this.props.personalizedName})
   }

   handleClick = () => {
      const { galleryId, setJourneyNavStep, setPersonalizedName } = this.props
      let personalizedName = this.state.personalizedName === '' ? 'Museum Guest' : this.state.personalizedName
      setJourneyNavStep(galleryId, 4)
      setPersonalizedName(galleryId, personalizedName)
   }

   _handleInput = (char) => {
      let { personalizedName } = this.state;

      if (char === 'BACKSPACE') {
         personalizedName = personalizedName.slice(0,-1);
      } else if(personalizedName.length <= 12) {
         personalizedName += char.toLowerCase();
      }

      this.setState({personalizedName})
   }

   updateInputValue = (evt) => {
      if (evt.keyCode === 13) {
         this.handleClick()
      }
      this.setState({personalizedName: evt.target.value})
   }
   
   render() {
      return   (
            <div className={'customize-journey-container'}>
               <div className={'bordered-container title'}>
                  <div className={'large-2 title-1 border'}>
                     <strong>Customize</strong> your journey, <br/>Enter your name below!
                  </div>
               </div>
               <div className={'input-container'}>
                  <input className={'enter-name large-3'} 
                     value={this.state.personalizedName} 
                     onChange={this.updateInputValue} 
                     onKeyPress={(e) => {if (e.key === 'Enter') this.handleClick() }}
                     />
                  <Hammer onTap={this.handleClick} options={tapOptions} >
                     <button className={'add-name medium-3'}>Add Your Name</button>
                  </Hammer>
               </div>
                  <Keyboard clickHandler={this._handleInput} />
            </div>
      )
   }
}

const mapStateToProps = (state, ownProps) => {
   return {
      personalizedName: personalizedName(state, ownProps),
     ...ownProps
   }
}
const mapDispatchToProps = dispatch => bindActionCreators({
   setJourneyNavStep,
   setPersonalizedName
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EnterYourName)


// WEBPACK FOOTER //
// ./src/components/FinalizeJourney/EnterYourName.js